import { render, staticRenderFns } from "./traffic-retrograde.vue?vue&type=template&id=b67d867a&scoped=true&"
import script from "./traffic-retrograde.vue?vue&type=script&lang=ts&"
export * from "./traffic-retrograde.vue?vue&type=script&lang=ts&"
import style0 from "./traffic-retrograde.vue?vue&type=style&index=0&id=b67d867a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67d867a",
  null
  
)

export default component.exports